module.exports = __webpack_public_path__ + "img/覆盆子.0c7d6e53.jpg";